import { MeasurementInputType } from '../../app/types';

interface MeasurementInputTypeDisplayProps {
  value: MeasurementInputType;
};

function MeasurementInputTypeDisplay(props: MeasurementInputTypeDisplayProps) {
  const { value } = props;
  switch (value) {
    case MeasurementInputType.EntryInput:
      return (<span>Entries</span>);
    case MeasurementInputType.ChecklistInput:
      return (<span>Checklist</span>);
  }
  return <></>;
}

export default MeasurementInputTypeDisplay;